import { Expose } from 'class-transformer';
import { BaseEntity } from './base.entity';

export class DecryptedCodeResponse extends BaseEntity {
  @Expose()
  public decrypted: string;
}
